import { ReactNode } from 'react';
import { isValidElementType } from 'react-is';
import { TypeGuard } from 'typesafe-utils';

export const isReactNode = <T>(value: T): value is TypeGuard<ReactNode, T> => isValidElementType(value);
